import getCookie from "../Utils/getCookie";
import { refreshOnce } from "../Utils/auth/refreshSession";
import { API_URL } from "./const";
import axios from "axios";

const baseURL = API_URL;

const axiosInstance = axios.create({
  baseURL,
});

const language = localStorage.getItem("lang") || "en";

axiosInstance.interceptors.request.use(async function (config) {
  const token = getCookie("token-siraj");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    // Ensure we don't send an invalid Authorization header on unauthenticated requests (e.g., login)
    if (config.headers && "Authorization" in config.headers) delete config.headers.Authorization;
  }
  config.headers["x-api-key"] = `58b53900-9ab8-4367-b328-4a17f6818833`;
  config.headers["accept-language"] = language.toLowerCase();
  // config.headers["Cache-Control"] = "no-cache";
  // config.headers["Pragma"] = "no-cache";
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const token = getCookie("token-siraj");
    const status = error?.response?.status;
    const redirectDestination = error?.response?.data?.redirect;
    const url = error?.config?.url;
    if (
      status === 403 &&
      redirectDestination &&
      url !== "user/registerFCM" &&
      token
    ) {
      // if (redirectDestination &&  ) {
      window.location.replace(redirectDestination);
      // }
    }
    const requestUrl = String(url || "");
    const canRefresh =
      status === 401 &&
      error?.config &&
      !error.config._retry &&
      !requestUrl.includes("auth/login") &&
      !requestUrl.includes("auth/refresh_user");
    if (canRefresh) {
      error.config._retry = true;
      return refreshOnce()
        .then((data) => {
          error.config.headers = error.config.headers || {};
          error.config.headers.Authorization = `Bearer ${data.accessToken}`;
          return axiosInstance(error.config);
        })
        .catch(() => Promise.reject(error));
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
